import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { FaShieldAlt, FaHospital, FaHeartbeat } from "react-icons/fa";
import "./PriseEnChargeTable.css";

function IncapCondPart(props) {
  const context = useContext(AppContext);

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            {context.state.TypeSimulation === "Audit prévoyance" || props.Statut === "TNS Article 62" || props.Statut === "TNS individuel" ? (
              <>
                <Row>
                  <div className="prise-en-charge-container prise-en-charge-table-container">
                    <table className="mono">
                      <tbody>
                        <tr>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Montant de l'IJ
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Début de versement
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Fin de versement
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.MaladieComplementaire}
                              onKeyUp={context.handleMontantToTaux("MaladieComplementaire")}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ1} onChange={context.handleGestionIJ1("IJ1")} options={context.state.Tabij1} />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ2} onChange={context.handleGestionIJ2("IJ2")} options={context.state.Tabij2} />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.MaladieComplementaire2}
                              onChange={context.handleInputChange("MaladieComplementaire2")}
                              disabled={context.state.IJ2 !== "1095" ? false : true}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.IJ3} onChange={context.handleInputChange("IJ3")} disabled dataType="uint" format={{ thousands: " ", unit: " jours" }} />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ4} onChange={context.handleGestionIJ("IJ4")} options={context.state.Tabij4} />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.MaladieComplementaire3}
                              onChange={context.handleInputChange("MaladieComplementaire3")}
                              disabled={context.state.IJ2 !== "1095" && context.state.IJ4 !== "1095" ? false : true}
                              dataType="uint"
                              format={{ thousands: " ", unit: " €" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.IJ5} onChange={context.handleInputChange("IJ5")} disabled dataType="uint" format={{ thousands: " ", unit: " jours" }} />
                          </td>
                          <td>
                            <DropDown
                              value={context.state.IJ6}
                              onChange={context.handleInputChange("IJ6")}
                              disabled={context.state.IJ2 !== "1095" && context.state.IJ4 !== "1095" ? false : true}
                              options={context.state.Tabij6}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Franchise réduite accident"
                      labelIcon={<FaShieldAlt />}
                      value={context.state.FranchiseAccidentComplementaire}
                      onChange={context.handleInputChange("FranchiseAccidentComplementaire")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " jours" }}
                      normal
                    />
                  </Column>
                  <Column>
                    <TextField
                      label="Franchise réduite hospitalisation"
                      labelIcon={<FaHospital />}
                      value={context.state.FranchiseHospitalisationComplementaire}
                      onChange={context.handleInputChange("FranchiseHospitalisationComplementaire")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " jours" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <TextField
                      label="Capital maladies redoutées"
                      labelIcon={<FaHeartbeat />}
                      value={context.state.CapitalMaladieRedoutee}
                      onChange={context.handleInputChange("CapitalMaladieRedoutee")}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      normal
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <DropDown
                      label="Rachat psy"
                      value={context.state.RachatPsy}
                      onChange={context.handleInputChange("RachatPsy")}
                      options={[
                        { value: "Non", label: "Non" },
                        { value: "Oui", label: "Oui" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                {context.state.RachatPsy === "Oui" && (
                  <Row>
                    <div className="prise-en-charge-container prise-en-charge-table-container">
                      <table className="mono">
                        <tbody>
                          <tr>
                            <td>
                              <label className="prise-en-charge-cell-label">Délai de carence</label>
                              <DropDown
                                value={context.state.RachatPsyCarence}
                                onChange={context.handleInputChange("RachatPsyCarence")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "Aucun" },
                                  { value: "90", label: "90 jours" },
                                  { value: "180", label: "180 jours" },
                                  { value: "365", label: "365 jours" },
                                ]}
                              />
                            </td>
                            <td>
                              <label className="prise-en-charge-cell-label">Condition de prise en charge</label>
                              <DropDown
                                value={context.state.RachatPsyDureeHospi}
                                onChange={context.handleInputChange("RachatPsyDureeHospi")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "Sans condition d'hospitalisation" },
                                  { value: "7", label: "Sans condition mais franchise minimale de 30 jours" },
                                  { value: "10", label: "Sans condition mais franchise minimale de 60 jours" },
                                  { value: "8", label: "Sans condition mais franchise minimale de 90 jours" },
                                  { value: "1", label: "3 jours en service psy ou 8 jours ailleurs" },
                                  { value: "9", label: "Hospitalisation de 3 jours" },
                                  { value: "2", label: "Hospitalisation de 5 jours" },
                                  { value: "3", label: "Hospitalisation de 8 jours" },
                                  { value: "4", label: "Hospitalisation de 10 jours" },
                                  { value: "5", label: "Hospitalisation de 14 jours" },
                                  { value: "6", label: "Hospitalisation de 15 jours" },
                                ]}
                              />
                            </td>
                            <td>
                              <label className="prise-en-charge-cell-label">Durée de versement</label>
                              <DropDown
                                value={context.state.RachatPsyDureeIJ}
                                onChange={context.handleInputChange("RachatPsyDureeIJ")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "365 jours" },
                                  { value: "1", label: "365 jours sauf intervention chirurgicale" },
                                  { value: "2", label: "365 jours sauf hospitalisation de + de 7 jours" },
                                  { value: "3", label: "1095 jours" },
                                ]}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Row>
                )}
                <Row>
                  <Column>
                    <DropDown
                      label="Rachat dos"
                      value={context.state.RachatDos}
                      onChange={context.handleInputChange("RachatDos")}
                      options={[
                        { value: "Non", label: "Non" },
                        { value: "Oui", label: "Oui" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                {context.state.RachatDos === "Oui" && (
                  <Row>
                    <div className=" prise-en-charge-container prise-en-charge-table-container">
                      <table className="mono">
                        <tbody>
                          <tr>
                            <td>
                              <label className="prise-en-charge-cell-label">Délai de carence</label>
                              <DropDown
                                value={context.state.RachatDosCarence}
                                onChange={context.handleInputChange("RachatDosCarence")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "Aucun" },
                                  { value: "90", label: " 90 jours" },
                                  { value: "180", label: " 180 jours" },
                                  { value: "365", label: " 365 jours" },
                                ]}
                              />
                            </td>
                            <td>
                              <label className="prise-en-charge-cell-label">Condition de prise en charge</label>
                              <DropDown
                                value={context.state.RachatDosDureeHospi}
                                onChange={context.handleInputChange("RachatDosDureeHospi")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "Sans condition d'hospitalisation" },
                                  { value: "6", label: "Sans condition mais franchise minimale de 30 jours" },
                                  { value: "9", label: "Sans condition mais franchise minimale de 60 jours" },
                                  { value: "7", label: "Sans condition mais franchise minimale de 90 jours" },
                                  { value: "8", label: "Couvert si une intervention chirurgicale est nécessaire" },
                                  { value: "1", label: "Hospitalisation de 24h" },
                                  { value: "2", label: "Hospitalisation de 24h ou intervention chirurgicale" },
                                  { value: "3", label: "Hospitalisation de 48h" },
                                  { value: "4", label: "Hospitalisation de 48h ou intervention chirurgicale" },
                                  { value: "5", label: "Hospitalisation de 7 jours" },
                                ]}
                              />
                            </td>
                            <td>
                              <label className="prise-en-charge-cell-label">Durée de versement</label>
                              <DropDown
                                value={context.state.RachatDosDureeIJ}
                                onChange={context.handleInputChange("RachatDosDureeIJ")}
                                options={[
                                  { value: "NC", label: "Non communiqué" },
                                  { value: "0", label: "365 jours" },
                                  { value: "1", label: "365 jours sauf intervention chirurgicale" },
                                  { value: "2", label: "365 jours sauf hospitalisation de + de 48h" },
                                  { value: "3", label: "1095 jours" },
                                ]}
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Row>
                )}
              </>
            ) : (
              <>
                <Row>
                  <Column>
                    <DropDown
                      label="Assiette de calcul"
                      value={context.state.BaseMaladieComplementaireSalarie}
                      onChange={context.handleInputChange("BaseMaladieComplementaireSalarie")}
                      options={[
                        { value: "SalaireBrut", label: "Salaire brut" },
                        { value: "SalaireNet", label: "Salaire net" },
                      ]}
                      normal
                    />
                  </Column>
                </Row>
                <Row>
                  <div className="prise-en-charge-container prise-en-charge-table-container">
                    <table className="mono">
                      <tbody>
                        <tr>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Montant de l'IJ
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Début de versement
                            </label>
                          </td>
                          <td>
                            <label className="prise-en-charge-cell-label" style={{ textAlign: "center" }}>
                              Fin de versement
                            </label>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.PourcentageMaladieComplementaireSalarie}
                              onChange={context.handleInputChange("PourcentageMaladieComplementaireSalarie")}
                              dataType="ufloat"
                              format={{ thousands: " ", decimmal: ",", precision: 2, unit: "%" }}
                            />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ1} onChange={context.handleGestionIJ1("IJ1")} options={context.state.Tabij1} />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ2} onChange={context.handleGestionIJ2("IJ2")} options={context.state.Tabij2} />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.PourcentageMaladieComplementaireSalarie2}
                              onChange={context.handleInputChange("PourcentageMaladieComplementaireSalarie2")}
                                disabled={context.state.IJ2 !== "1095" ? false : true}
                              dataType="ufloat"
                              format={{ thousands: " ", decimmal: ",", precision: 2, unit: "%" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.IJ3} onChange={context.handleInputChange("IJ3")} disabled dataType="uint" format={{ thousands: " ", unit: " jours" }} />
                          </td>
                          <td>
                            <DropDown value={context.state.IJ4} onChange={context.handleGestionIJ("IJ4")} options={context.state.Tabij4} />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <TextField
                              value={context.state.PourcentageMaladieComplementaireSalarie3}
                              onChange={context.handleInputChange("PourcentageMaladieComplementaireSalarie3")}
                              disabled={context.state.IJ2 !== "1095" && context.state.IJ4 !== "1095" ? false : true}
                              dataType="ufloat"
                              format={{ thousands: " ", decimmal: ",", precision: 2, unit: "%" }}
                            />
                          </td>
                          <td>
                            <TextField value={context.state.IJ5} onChange={context.handleInputChange("IJ5")} disabled dataType="uint" format={{ thousands: " ", unit: " jours" }} />
                          </td>
                          <td>
                            <DropDown
                              value={context.state.IJ6}
                              onChange={context.handleInputChange("IJ6")}
                              disabled={context.state.IJ2 !== "1095" && context.state.IJ4 !== "1095" ? false : true}
                              options={context.state.Tabij6}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </Row>
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default IncapCondPart;
